/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  FastEndpointsProblemDetails,
} from '../models/index';
import {
    FastEndpointsProblemDetailsFromJSON,
    FastEndpointsProblemDetailsToJSON,
} from '../models/index';

export interface GetFxIdWebFeaturesRedirectGoEndpointRequest {
    url: string;
    fxref?: number | null;
    type?: string | null;
}

/**
 * 
 */
export class GoApi extends runtime.BaseAPI {

    /**
     */
    async getFxIdWebFeaturesRedirectGoEndpointRaw(requestParameters: GetFxIdWebFeaturesRedirectGoEndpointRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['url'] == null) {
            throw new runtime.RequiredError(
                'url',
                'Required parameter "url" was null or undefined when calling getFxIdWebFeaturesRedirectGoEndpoint().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['url'] != null) {
            queryParameters['url'] = requestParameters['url'];
        }

        if (requestParameters['fxref'] != null) {
            queryParameters['fxref'] = requestParameters['fxref'];
        }

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/go`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async getFxIdWebFeaturesRedirectGoEndpoint(url: string, fxref?: number | null, type?: string | null, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getFxIdWebFeaturesRedirectGoEndpointRaw({ url: url, fxref: fxref, type: type }, initOverrides);
    }

    /**
     */
    async postFxIdWebFeaturesRedirectGoEndpointRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/go`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async postFxIdWebFeaturesRedirectGoEndpoint(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postFxIdWebFeaturesRedirectGoEndpointRaw(initOverrides);
    }

}
